import { gsap } from 'gsap';
import ControllerBringSymbolsToFront from './ControllerBringSymbolsToFront';
import SoundManager from 'Engine/soundManager/SoundManager';
import { eSounds } from '../../enums/eSounds';

export default class ControllerWinCombination {
  constructor({ reelsContainer, controllerReels, topContainer }) {
    this.ControllerReels = controllerReels;
    this.containerReels = reelsContainer;
    this.ControllerBringToFrontSymbols = new ControllerBringSymbolsToFront(topContainer);
    // this._initOverlay();

    this._soundPlayed = false;
    this._sounds = [eSounds.EST_WIN];
  }

  startWinnings({ params }) {
    this._setAllSymbolsActive(false);
    const dalayOffset = 120;
    params.forEach((stepData) => {
      stepData.positions.forEach((position, index) => {
        if (position.length === 2) {
          const symbol = this.ControllerReels.reels[position[0]].symbols[1].symbols[position[1]];
          symbol.setActive(true);
          const delay = dalayOffset * position[0];
          setTimeout(()=> {
            symbol.startFire();
          }, delay);
        } else  {
          console.error(`win_lines[#].positions[${index}].length !== 2`)
        }
      });
    })
  }

  showCombination({ params }) {
    // this.overlay.visible = true;
    // gsap.to(this.overlay, { alpha: 1, duration: 0.2 });
    let sound = this._sounds[0];

    this.ControllerReels.reels.forEach(reel => {
      reel.symbols[1].stopAnimation();
    });

    params.positions.forEach((position, index) => {
      if (position.length === 2) {
        const symbol = this.ControllerReels.reels[position[0]].symbols[1].symbols[position[1]];
        // this.ControllerBringToFrontSymbols.bringToFront(symbol);
        symbol.startAnimation();
        sound = this._sounds[symbol.id] || sound;
      } else  {
        console.error(`win_lines[#].positions[${index}].length !== 2`)
      }
    });

    if (!this._soundPlayed) {
      SoundManager.play(sound.soundName, sound.volume, false, sound.group);
      this._soundPlayed = true;
    }
  }

  showBonusGameStart(symbols) {
    this._setAllSymbolsActive(false);
    // this.overlay.visible = true;
    // gsap.to(this.overlay, { alpha: 1, duration: 0.2 });
    symbols.forEach(symbol => {
      this.ControllerBringToFrontSymbols.bringToFront(symbol);
      symbol.setActive(true);
      symbol.startAnimation();
    });
  }

  end() {
    this._soundPlayed = false;
    this._setAllSymbolsActive(true);
    // this._stopAllSymbolsFire();
    // this.ControllerBringToFrontSymbols.bringAllBack();
    // if (this.overlay.visible) {
    //   gsap.to(this.overlay, {
    //     alpha: 0, duration: 0.2, onComplete: () => {
    //       this.overlay.visible = false;
    //     }
    //   });
    // }
  }

  _setAllSymbolsActive(value) {
    this.ControllerReels.reels.forEach(reel => reel.symbols.forEach(symbol => {
      symbol.setActive(value);
    }));
  }

  _stopAllSymbolsFire() {
    this.ControllerReels.reels.forEach(reel => reel.symbols.forEach(symbol => {
      symbol.stopFire();
    }));
  }

  _initOverlay() {
    // this.overlay = new PIXI.Graphics();
    // this.containerReels.addChildAt(this.overlay, 0);
    //
    // this.overlay.beginFill(0x080342, 0.75);
    // this.overlay.drawRoundedRect(-40, -2, 1250, 805, 16);
    // this.overlay.endFill();
    // this.overlay.visible = false;
  }
}
